<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div :class="page === 'selectMethod' ? 'row' : 'd-flex justify-content-center'">
                    <div v-if="page === 'selectMethod'" class="col-xs-0 col-sm-0 col-md-3 col-lg-3"></div>
                    <div :class="page === 'selectMethod' ? 'col-xs-12 col-sm-12 col-md-6 col-lg-6' : ''">
                        <div 
                            class="modal-container" 
                            :class="{ 
                                'modal-file-mode': page === 'file', 
                                'modal-satuan-mode': page === 'satuan', 
                                'modal-select-mode': page === 'selectMethod' 
                            }" 
                            @click.stop
                        >

                            <!-- Header for file mode -->
                            <div 
                                v-if="page === 'file'"
                                class="modal-header-custom modal-header-file d-flex justify-content-between align-items-center"
                            >
                                <div class="d-flex align-items-center">
                                    <h5 class="modal-title-custom mb-0">{{ title }}</h5>
                                </div>
                                <button class="btn btn-close-custom" @click="$emit('closeModal')">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>

                            <!-- Header for satuan mode -->
                            <div 
                                v-else-if="page === 'satuan'"
                                class="modal-header-custom modal-header-satuan d-flex justify-content-between align-items-center"
                            >
                                <div class="d-flex align-items-center">
                                    <button
                                        type="button"
                                        class="back-btn mr-2"
                                        @click="page = masterPage.length > 1 ? 'selectMethod' : $emit('closeModal')"
                                        aria-label="Kembali"
                                    >
                                        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.44256 7.93462C6.61274 7.84281 6.71884 7.66823 6.71884 7.47835V4.52166H12.5569C12.8517 4.52166 13.0909 4.28797 13.0909 4.00002C13.0909 3.71207 12.8517 3.47837 12.5569 3.47837H6.71884V0.521683C6.71884 0.331108 6.61274 0.156531 6.44256 0.0654168C6.27239 -0.0270885 6.06447 -0.0208287 5.89999 0.0800228L0.249215 3.55836C0.0939897 3.65434 0 3.82057 0 4.00002C0 4.17947 0.0939897 4.3457 0.249215 4.44168L5.89999 7.92001C5.98686 7.97287 6.08583 8 6.1848 8C6.2731 8 6.3621 7.97774 6.44256 7.93462Z" fill="#111827"/>
                                        </svg>
                                    </button>
                                    <h5 class="modal-title-custom mb-0">{{ title }}</h5>
                                </div>
                                <button class="btn btn-close-custom" @click="$emit('closeModal')">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>

                            <!-- Header for selectMethod mode -->
                            <div v-else class="modal-header row" style="justify-content: space-between;border-bottom: none;">
                                <div class="col">
                                    <div class="d-flex flex-start">
                                        <div class="flex-item mr-2" style="cursor: pointer;" @click="$emit('closeModal')"><i class="fa fa-arrow-left"></i></div>
                                        <div class="flex-item"><h5>{{ title }}</h5></div>
                                    </div>
                                </div>
                                <div class="col">
                                    <button type="button" class="close" @click="$emit('closeModal')">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <hr class="mt-0" v-if="page === 'selectMethod'">

                            <div v-if="page === 'selectMethod'" class="modal-body text-center p-10">
                                <div class="mb-3">
                                    <b-container>
                                        <b-row class="justify-content-center">
                                        <b-col cols="12" md="5" class="p-10" @click="page = 'satuan'">
                                           <div class="boxHover border border-grey rounded text-center d-flex flex-column align-items-center justify-content-center pl-4 pr-4" style="height:350px; color: #000000;">
                                                <img src="@/assets/img/icon/pengiriman-satuan.png" style="width:auto;height: 5em;" class="mb-4"/>
                                                <h3 style="color: #000000;">Pengiriman Satuan</h3>
                                                <p style="color: #000000;">Buat pengiriman untuk satu destinasi pos</p>
                                            </div>
                                        </b-col>
                                        <b-col cols="12" md="5" class="p-10" @click="page = 'file'">
                                            <div class="boxHover border border-grey rounded text-center d-flex flex-column align-items-center justify-content-center pl-4 pr-4" style="height:350px; color: #000000;">
                                                <img src="@/assets/img/icon/pengiriman-gabungan.png" style="width:auto;height: 5em;" class="mb-4"/>
                                            <h3 style="color: #000000;">Pengiriman Gabungan</h3>
                                            <p style="color: #000000;">Buat pengiriman untuk berbagai destinasi pos</p>
                                            </div>
                                        </b-col>
                                        </b-row>
                                    </b-container>
                                </div>
                            </div>

                            <!-- Body for satuan mode -->
                            <div v-else-if="page === 'satuan'" class="modal-body-satuan">
                                <!-- Pos Tujuan -->
                                <div class="modal-form-row">
                                    <label class="modal-form-label mb-0">Pos Tujuan</label>
                                    <div class="modal-form-input">
                                        <Multiselect
                                            v-model="satuan.kode_dealer"
                                            :options="posData.map(x => x.code)"
                                            :custom-label="opt => posLabel(opt)"
                                            placeholder="Pilih Pos Tujuan"
                                            :show-labels="false"
                                            :searchable="true"
                                            :allow-empty="false"
                                            class="custom-modal-select qtrust-select"
                                        />
                                    </div>
                                </div>

                                <!-- Jumlah QR -->
                                <div class="modal-form-row">
                                    <label class="modal-form-label mb-0">Jumlah QR</label>
                                    <div class="modal-form-input">
                                        <Multiselect
                                            v-model="satuan.qty"
                                            :options="qtyOptions"
                                            :custom-label="getQtyLabel"
                                            placeholder="Pilih Jumlah QR"
                                            :show-labels="false"
                                            :searchable="true"
                                            :taggable="true"
                                            @tag="addQtyTag"
                                            :allow-empty="false"
                                            class="custom-modal-select qtrust-select"
                                        />
                                        <span v-if="qtyExceedsMax" class="text-danger d-block mt-1" style="font-size: 11px; text-align: left;">
                                            Jumlah QR melebihi batas. Maksimal {{ numberWithCommas(maxQty) }} QR
                                        </span>
                                    </div>
                                </div>

                                <!-- Tanda Tangan -->
                                <div class="modal-form-row align-top">
                                    <label class="modal-form-label mb-0 pt-1">Tanda Tangan</label>
                                    <div class="modal-form-input">
                                        <div class="signature-box-satuan">
                                            <vue-signature-pad width="100%" height="116px" ref="signaturePad" :options="{ onEnd: onSignatureEnd }" />
                                            <button
                                                type="button"
                                                class="btn-clear-sig-satuan"
                                                @click="$refs.signaturePad.clearSignature(); hasSignature = false"
                                            >
                                                Hapus
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Actions -->
                                <div class="modal-actions-row-satuan d-flex justify-content-end align-items-center">
                                    <button 
                                        type="button" 
                                        class="btn btn-batal" 
                                        @click="$emit('closeModal')"
                                    >
                                        Batal
                                    </button>
                                    <button 
                                        type="button" 
                                        class="btn btn-kirim" 
                                        :class="{ 'btn-kirim-disabled': !canSubmit }"
                                        :disabled="!canSubmit"
                                        @click="submitIssue"
                                    >
                                        Kirim
                                    </button>
                                </div>
                            </div>

                            <!-- Body for file mode -->
                            <div v-else class="modal-body-file">
                                <!-- Upload Box -->
                                <div 
                                    class="upload-dropzone"
                                    @drop.prevent="validateSize"
                                    @dragover.prevent
                                >
                                    <img src="@/assets/img/icon/upload-csv.png" class="upload-icon" alt="Upload CSV" />
                                    <h6 class="upload-title">Upload CSV</h6>
                                    <p class="upload-subtitle">Seret dan masukkan file CSV untuk memulai upload</p>
                                    
                                    <label class="custom-file-btn mb-0">
                                        <input type="file" @change="validateSize" accept=".csv, .xlsx, .xls" hidden />
                                        <span class="btn-choose">Choose File</span>
                                        <span class="file-name">{{ file ? file.name : 'data pos.csv' }}</span>
                                    </label>
                                    
                                    <p v-if="fileError" class="text-danger mt-2 mb-0 font-weight-normal" style="font-size: 11px;">{{ fileError }}</p>
                                </div>

                                <!-- Template Hint -->
                                <div class="template-hint">
                                    <span>jika anda tidak mempunyai templatenya download <a href="/template/Data pengiriman Sticker QR Code ke Dealer atau AHASS.xlsx" class="link-download">disini</a></span>
                                </div>

                                <!-- Signature Row -->
                                <div class="signature-form-row">
                                    <label class="signature-label mb-0">Tanda Tangan</label>
                                    <div class="signature-box">
                                        <vue-signature-pad width="100%" height="116px" ref="signaturePad" />
                                        <button
                                            type="button"
                                            class="btn-clear-sig"
                                            @click="$refs.signaturePad.clearSignature()"
                                        >
                                            Hapus
                                        </button>
                                    </div>
                                </div>

                                <!-- Actions -->
                                <div class="modal-actions-row">
                                    <button 
                                        type="button" 
                                        class="btn btn-batal" 
                                        @click="$emit('closeModal')"
                                    >
                                        Batal
                                    </button>
                                    <button 
                                        type="button" 
                                        class="btn btn-konfirmasi" 
                                        @click="uploadFile"
                                    >
                                        Konfirmasi
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="page === 'selectMethod'" class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
            </div>
        </div>
    </transition>
</template>

<script>
    import moment from 'moment'
    import Multiselect from 'vue-multiselect';
    import { fetchTransferQtyOptions } from '@/services/transfer-qty-options';

    export default {
        components :{
            Multiselect
        },
        props: {
            saldoQr: {
                type: Number,
                default: 0,
            },
        },
        computed: {
            maxQty() {
                return Math.max(0, this.saldoQr);
            },
            qtyExceedsMax() {
                return Number(this.satuan.qty) > this.maxQty;
            },
            qtyOptions() {
                const defaults = this.transferQtyOptions && this.transferQtyOptions.length > 0
                    ? this.transferQtyOptions
                    : [];
                const current = Number(this.satuan.qty);
                if (current && !defaults.includes(current)) {
                    return [current, ...defaults].sort((a, b) => a - b);
                }
                return defaults;
            },
            canSubmit() {
                return !!this.satuan.kode_dealer
                    && Number(this.satuan.qty) > 0
                    && this.saldoQr > 0
                    && !this.qtyExceedsMax
                    && this.hasSignature;
            },
        },
        data() {
            return {
                moment,
                page : 'satuan',
                title : 'Edit Pengiriman Satuan',
                masterPage : [{
                    page : 'satuan',
                    title : 'Edit Pengiriman Satuan'
                }],
                satuan : {
                    kode_dealer : '',
                    qty : '',
                    // bast_no : '',
                    sender_signature : null
                },
                posData : [],
                hasSignature : false,
                file : null,
                fileError : "",
                transferQtyOptions: []
            }
        },
        // return {
        //         moment,
        //         page : 'selectMethod',
        //         title : 'Metode Pengiriman',
        //         masterPage : [{
        //             page : 'selectMethod',
        //             title : 'Metode Pengiriman'
        //         },{
        //             page : 'file',
        //             title : 'Pengiriman Gabungan'
        //         },{
        //             page : 'satuan',
        //             title : 'Edit Pengiriman Satuan'
        //         }],
        //         satuan : {
        //             kode_dealer : '',
        //             qty : '',
        //             // bast_no : '',
        //             sender_signature : null
        //         },
        //         posData : [],
        //         hasSignature : false,
        //         file : null,
        //         fileError : ""
        //     }
        // },
        watch : {
            page : function () {
                this.title = this.masterPage.find(x => this.page == x.page).title

                this.resetBody()
            }
        },
        mounted() {
            this.loadPosOptions()
            this.loadTransferQtyOptions()
            // this.loadBastCode()
        },
        methods: {
            async loadTransferQtyOptions() {
                try {
                    this.transferQtyOptions = await fetchTransferQtyOptions(this.$http);
                } catch (err) {
                    // Fallback to default
                }
            },
            async loadPosOptions () {
                try {
                    let response = await this.$http.get('/api/master/pos')

                    this.posData = response.data.data
                }
                catch(err) {
                    console.log(err)
                }
            },
            async loadBastCode () {
                try {
                    let response = await this.$http.get('/api/qrs/issue/bast')

                    this.satuan.bast_no = response.data.data
                }
                catch(err) {
                    console.log(err)
                }
            },
            resetBody() {
                this.satuan.kode_dealer = ''
                this.satuan.qty = ''
                this.hasSignature = false
                // this.satuan.bast_no = ''
            },
            onSignatureEnd() {
                this.hasSignature = true
            },
            async submitIssue() {
                try {
                    const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

                    let errors = [];
                    if (isEmpty) {
                        throw new Error('Signature is required')
                    }

                    if (this.satuan.qty == 0) errors.push('Jumlah QR tidak boleh 0')

                    if (errors.length > 0) {
                        this.$swal.fire({
                            title: "Error",
                            html: `<p>> ${errors.join("<br>> ")}</p>`,
                            icon: "error",
                        });
                        return;
                    }

                const confirmResult = await this.$swal.fire({
                        html: `
                            <div class="swal-confirm-header">
                                <span class="swal-confirm-title">Konfirmasi Pengiriman QR</span>
                            </div>
                            <div class="swal-confirm-content">
                                <div class="swal-confirm-icon">
                                    <svg width="124" height="112" viewBox="0 0 124 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M53.493 2.18918C61.9236 -2.48607 72.6478 0.58571 77.359 8.94096L122.425 87.1547C123.417 89.4893 123.851 91.3877 123.975 93.3597C124.223 97.9674 122.611 102.446 119.45 105.893C116.288 109.327 112.011 111.354 107.362 111.6H16.6092C14.6875 111.483 12.7659 111.047 10.9682 110.371C1.97967 106.747 -2.3596 96.5482 1.29778 87.7077L46.6741 8.88567C48.2239 6.11492 50.5795 3.72507 53.493 2.18918ZM61.9856 76.0902C59.0101 76.0902 56.5305 78.5476 56.5305 81.5027C56.5305 84.4454 59.0101 86.909 61.9856 86.909C64.9611 86.909 67.3786 84.4454 67.3786 81.4351C67.3786 78.4923 64.9611 76.0902 61.9856 76.0902ZM61.9856 37.7604C59.0101 37.7604 56.5305 40.1503 56.5305 43.1054V60.4855C56.5305 63.4344 59.0101 65.898 61.9856 65.898C64.9611 65.898 67.3786 63.4344 67.3786 60.4855V43.1054C67.3786 40.1503 64.9611 37.7604 61.9856 37.7604Z" fill="#F36F21"/>
                                    </svg>
                                </div>

                                <div class="swal-confirm-text">
                                    Anda akan yakin mengirim <strong>${this.satuan.qty}</strong> QR ke
                                    <br>
                                    <strong>${this.posLabel(this.satuan.kode_dealer)}</strong>
                                    <br>
                                    <br>
                                    Apa anda yakin sudah benar?
                                </div>
                            </div>
                        `,
                        showCancelButton: true,
                        showCloseButton: true,
                        confirmButtonText: "Ya, Kirim",
                        cancelButtonText: "Batal",
                        reverseButtons: true,
                        customClass: {
                            popup: 'swal2-popup-confirm',
                            cancelButton: 'swal-btn-cancel',
                            confirmButton: 'swal-btn-confirm'
                        }
                    });

                    const isConfirmed = confirmResult && (confirmResult.isConfirmed || confirmResult.value === true);
                    if (!isConfirmed) return;

                    const payload = {
                        kode_dealer: this.satuan.kode_dealer,
                        qty: Number(this.satuan.qty),
                        sender_signature: data.split(",")[1]
                    };

                    await this.$http.post('/api/qrs/issue/create', payload);

                    this.$emit('updateTable')
                    this.resetBody()
                }
                catch(err) {
                    console.log(err)
                    this.$swal.fire({
                        title: "Error",
                        text: `Gagal mengirim QR: ${err && err.message ? err.message : err}`,
                        icon: "error",
                    });
                }
            },
            posLabel(code) {
                if (!code) return '';
                const pos = this.posData.find(x => x.code === code);
                return pos ? `${pos.code} - ${pos.name}` : code;
            },
            getQtyLabel(val) {
                if (val === null || val === undefined || val === '') return '';
                return `${Number(val).toLocaleString()} QR`;
            },
            addQtyTag(newTag) {
                const num = parseInt(newTag.toString().replace(/[^0-9]/g, ''), 10);
                if (!isNaN(num) && num > 0) {
                    this.satuan.qty = num;
                }
            },
            numberWithCommas(x) {
                if (!x && x !== 0) return '0';
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
            validateSize : function(data){
                var file = data.dataTransfer ? data.dataTransfer.files[0] : data.target.files[0];
                console.log(file)

                if(file.type != "text/csv" && file.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type != 'application/vnd.ms-excel')
                {
                    this.fileError = "Unsupported File Type! Only accepts CSV or XLSX Files";
                    return false;
                }

                var size  = file.size / 1024 / 1024;

                if(size > 2)
                {
                    this.fileError = "File size is too big";
                    return false;
                }

                this.fileError = "";
                this.file = file;

                return true;
            },
            uploadFile : function(){
                let vm = this;
                let url = "/api/qrs/issue/upload"
                
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();


                let errors = [];
                if (isEmpty) errors.push("Signature is required");
                if (!this.file) errors.push("Please Upload Document First Before Submitting Document");

                if (errors.length > 0) {
                    this.$swal.fire({
                        title: "Error",
                        html: `<p>> ${errors.join("<br>> ")}</p>`,
                        icon: "error",
                    });
                    return;
                }

                let formData = new FormData();

                let dataSignature = data.split(",")[1];

                formData.append('file' , this.file);
                formData.append('sender_signature' , dataSignature);

                this.$http.post(url , formData , {headers : {"Content-Type":'multipart/form-data'}})
                .then((resp)=>{
                    if (resp.data.code != 200) {
                        this.$swal.fire({
                            title: "Error",
                            text: resp.data.message,
                            icon: "error",
                        });
                        return;
                    }

                    this.$swal.fire({
                        title: "Success",
                        text: "Bulk Input Success",
                        icon: "success",
                    });

                    vm.$emit('updateTable');
                    vm.$emit('closeModal')
                })
                .catch((err)=>{
                    console.log(err);
                    this.$swal.fire({
                        title: "Error",
                        text: "Bulk Input Failed: " + err,
                        icon: "error",
                    });
                })
                
            }
        }
    }
</script>
<style>
   .mpm-button-satuan-submit {
    background-color: #F36F21 !important;
    color: #ffffff !important;
    border: 1px solid #F36F21 !important;
    }

    .mpm-button-satuan-submit.mpm-button-disabled,
    .mpm-button-satuan-submit.mpm-button-disabled:hover,
    .mpm-button-satuan-submit.mpm-button-disabled:focus,
    .mpm-button-satuan-submit.mpm-button-disabled:active {
        background-color: #CBCBCB !important;
        border-color: #CBCBCB !important;
        color: #FFFFFF !important;
        cursor: not-allowed;
    }

    .b-card {
        border: none; /* Removes border */
        box-shadow: 0 4px 8px rgba(0,0,0,0.1); /* Adds shadow for depth */
        padding: 20px; /* Adds some padding inside the card */
        margin: 20px 0; /* Adds vertical spacing */
    }

    b-icon {
        margin-bottom: 20px; /* Space between icon and text */
    }

    .swal2-popup-confirm .swal-confirm-header {
        min-height: 24px;
        text-align: left;
        font-size: 16px;
        color: #000000;
        font-weight: 600;
        }
    .mpm-button-outline {
        background-color: #ffffff !important;
        color: #F36F21 !important;
        border: 1px solid #ffffff !important;
        height: 47px;
    }

    .mpm-button-satuan-submit {
        background-color: #F36F21 !important;
        color: #ffffff !important;
        border: 1px solid #F36F21 !important;
        height: 47px;
    }

    .swal2-popup-confirm .swal-confirm-icon {
        margin-bottom: 12px;
        margin-top: 8px;
        display: flex;
        justify-content: center;
        overflow: visible;
    }

    .swal2-popup-confirm .swal-confirm-icon svg {
        display: block;
        overflow: visible;
    }

    .swal2-popup-confirm .swal-confirm-text {
        font-size: 14px !important;
        font-weight: 400 !important;
        color: #000000 !important;
        line-height: 1.6 !important;
        text-align: center !important;
    }

    .swal2-popup-confirm .swal2-actions {
        width: 100%;
    }

    .swal2-popup-confirm .swal2-actions button {
        min-width: 150px !important;
        font-size: 14px !important;
    }

    .swal2-popup-confirm .swal-btn-cancel {
        background: #ffffff !important;
        color: #F36F21 !important;
        border: none !important;
    }

    .swal2-popup-confirm .swal-btn-confirm {
        background: #F36F21 !important;
        color: #ffffff !important;
        border: 1px solid #F36F21 !important;
    }
    .file-preview-box {
        background-color: #2F2F2F !important;
        border-color: #2F2F2F !important;
    }
    .file-upload-orange {
    background-color: #F36F21 !important;
    color: #ffffff !important;
    border: 1px solid #F36F21 !important;
    border-radius: 4px;
    padding: 6px 12px;
    }

    .file-upload-orange::-webkit-file-upload-button,
    .file-upload-orange::file-selector-button {
        background-color: #ffffff;
        color: #2F2F2F;
        border: none;
        border-radius: 4px;
        padding: 6px 16px;
        margin-right: 12px;
        cursor: pointer;
    }

    .custom-modal-select.multiselect {
        min-height: 30px !important;
    }

    .dealerDashboard .custom-modal-select.multiselect .multiselect__tags,
    .custom-modal-select .multiselect__tags {
        min-height: 30px !important;
        height: 30px !important;
        padding: 4px 30px 0 10px !important;
        border: 1px solid #E5E7EB !important;
        border-radius: 4px !important;
        background-color: #FFFFFF !important;
        background: #FFFFFF !important;
        box-shadow: none !important;
        box-sizing: border-box !important;
        display: block !important;
        width: 100% !important;
    }

    .dealerDashboard .custom-modal-select.multiselect .multiselect__placeholder,
    .custom-modal-select .multiselect__placeholder {
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-left: 0 !important;
        color: #9CA3AF !important;
        background-color: transparent !important;
        font-family: inherit !important;
        font-size: 13px !important;
        font-weight: 400 !important;
        line-height: 20px !important;
        display: inline-block !important;
    }

    .dealerDashboard .custom-modal-select.multiselect .multiselect__single,
    .custom-modal-select .multiselect__single {
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-left: 0 !important;
        font-size: 13px !important;
        font-weight: 400 !important;
        font-family: inherit !important;
        color: #1F2937 !important;
        background-color: transparent !important;
        line-height: 20px !important;
        display: inline-block !important;
    }

    .dealerDashboard .custom-modal-select.multiselect .multiselect__select,
    .custom-modal-select .multiselect__select {
        width: 30px !important;
        height: 28px !important;
        padding: 0 !important;
        top: 1px !important;
        right: 1px !important;
        background-color: transparent !important;
    }

    .dealerDashboard .custom-modal-select.multiselect .multiselect__select::before,
    .custom-modal-select .multiselect__select::before {
        border-color: #6B7280 transparent transparent !important;
        border-width: 5px 4px 0 4px !important;
        top: 55% !important;
        margin: 0 !important;
    }

    .dealerDashboard .custom-modal-select.multiselect .multiselect__input,
    .custom-modal-select .multiselect__input {
        min-height: 20px !important;
        font-size: 13px !important;
        padding: 0 !important;
        margin-bottom: 0 !important;
        line-height: 20px !important;
        background-color: transparent !important;
        color: #1F2937 !important;
        display: inline-block !important;
    }

    .custom-modal-select .multiselect__content-wrapper {
        border: 1px solid #E5E7EB !important;
        border-radius: 4px !important;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
        font-size: 13px !important;
        background-color: #FFFFFF !important;
    }

    .custom-modal-select .multiselect__option--highlight {
        background: #F36F21 !important;
        color: #FFFFFF !important;
    }

    .custom-modal-select .multiselect__option--selected.multiselect__option--highlight {
        background: #D95D16 !important;
        color: #FFFFFF !important;
    }
</style>
<style scoped>
    .boxHover:hover {
        background-color: rgb(85, 85, 85);
        color:white;
        cursor: pointer;
    }

    .border-grey {
        border-color: #e3e2e2 !important;
    }
    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 0;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-container.modal-file-mode {
        width: 521px !important;
        max-width: 521px !important;
        height: 562px;
        min-height: 562px;
        display: flex;
        flex-direction: column;
    }

    .modal-container.modal-satuan-mode {
        width: 521px !important;
        max-width: 521px !important;
        min-height: 357px;
        background-color: #FFFFFF;
        border-radius: 8px;
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
        padding: 0;
        overflow: hidden;
        transform: rotate(0deg);
        opacity: 1;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
    }

    .modal-header-satuan {
        padding: 12px 20px;
        border-bottom: 1px solid #F3F4F6;
        height: 48px;
        box-sizing: border-box;
    }

    .back-btn {
        background: transparent;
        border: none;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        outline: none;
        margin-right: 10px;
    }

    .modal-body-satuan {
        padding: 20px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        text-align: left;
    }

    .modal-form-row {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        width: 100%;
    }

    .modal-form-row.align-top {
        align-items: flex-start;
    }

    .modal-form-label {
        width: 112px;
        flex-shrink: 0;
        font-size: 14px;
        font-weight: 600;
        color: #2F2F2F;
        line-height: 30px;
    }

    .modal-form-row.align-top .modal-form-label {
        line-height: normal;
        padding-top: 4px;
    }

    .modal-form-input {
        flex: 1;
        min-width: 0;
    }

    .signature-box-satuan {
        width: 100%;
        height: 118px;
        border: 1px solid #E5E7EB;
        border-radius: 4px;
        position: relative;
        background: #FFFFFF;
        overflow: hidden;
        box-sizing: border-box;
    }

    .signature-box-satuan canvas {
        display: block;
        width: 100%;
        height: 116px !important;
    }

    .btn-clear-sig-satuan {
        position: absolute;
        bottom: 8px;
        right: 12px;
        background: transparent;
        border: none;
        color: #ADADAD;
        font-size: 13px;
        cursor: pointer;
        padding: 0;
        outline: none;
        z-index: 2;
    }

    .btn-clear-sig-satuan:hover {
        color: #6B7280;
    }

    .modal-actions-row-satuan {
        margin-top: 4px;
        width: 100%;
    }

    .modal-actions-row-satuan .btn-batal {
        background: transparent;
        border: none;
        color: #F36F21;
        font-size: 13px;
        font-weight: 500;
        padding: 0;
        margin-right: 28px;
        box-shadow: none;
        cursor: pointer;
    }

    .modal-actions-row-satuan .btn-batal:hover {
        color: #D95D16;
        background: transparent;
    }

    .modal-actions-row-satuan .btn-kirim {
        background-color: #F36F21;
        border: 1px solid #F36F21;
        color: #FFFFFF;
        font-size: 13px;
        font-weight: 500;
        border-radius: 4px;
        padding: 0;
        width: 100px;
        height: 31px;
        box-shadow: none;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
    }

    .modal-actions-row-satuan .btn-kirim:hover:not(:disabled) {
        background-color: #D95D16;
        border-color: #D95D16;
    }

    .modal-actions-row-satuan .btn-kirim:disabled,
    .modal-actions-row-satuan .btn-kirim.btn-kirim-disabled {
        background-color: #D1D5DB !important;
        border-color: #D1D5DB !important;
        color: #9CA3AF !important;
        cursor: not-allowed;
    }

    .modal-header-file {
        padding: 21px 18px 0 49px;
        border-bottom: none;
    }

    .modal-title-custom {
        font-size: 16px;
        font-weight: 600;
        color: #111827;
        line-height: 23px;
    }

    .btn-close-custom {
        padding: 0;
        border: none;
        background: transparent;
        color: #111827;
        font-size: 16px;
        cursor: pointer;
        line-height: 1;
    }

    .modal-header-file .btn-close-custom {
        margin-right: 0;
    }

    .modal-body-file {
        padding: 38px 56px 20px 48px;
        display: flex;
        flex-direction: column;
        text-align: left;
    }

    .upload-dropzone {
        width: 417px;
        height: 225px;
        border: 1px solid #E5E7EB;
        border-radius: 6px;
        padding-top: 47px;
        background-color: #FFFFFF;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        transition: border-color 0.2s;
    }

    .upload-icon {
        height: 50px;
        width: auto;
        object-fit: contain;
        margin-bottom: 30px;
    }

    .upload-title {
        font-size: 14px;
        font-weight: 600;
        color: #111827;
        margin-bottom: 15px;
        line-height: 1;
    }

    .upload-subtitle {
        font-size: 11px;
        color: #4B5563;
        margin-bottom: 17px;
        line-height: 1;
    }

    .custom-file-btn {
        display: inline-flex;
        align-items: center;
        background-color: #F36F21;
        border-radius: 4px;
        padding: 2px 12px 2px 4px;
        cursor: pointer;
        transition: background-color 0.2s;
        height: 26px;
        box-sizing: border-box;
    }

    .custom-file-btn:hover {
        background-color: #D95D16;
    }

    .custom-file-btn .btn-choose {
        background-color: #FFFFFF;
        color: #374151;
        border-radius: 3px;
        padding: 3px 10px;
        font-size: 11px;
        font-weight: 500;
        line-height: 1.2;
    }

    .custom-file-btn .file-name {
        color: #FFFFFF;
        font-size: 11px;
        font-weight: 400;
        margin-left: 10px;
        max-width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .template-hint {
        font-size: 11px;
        color: #374151;
        text-align: center;
        margin: 27px 0 26px 0;
        line-height: 14px;
    }

    .link-download {
        color: #4E80ED;
        text-decoration: none;
    }

    .link-download:hover {
        text-decoration: underline;
    }

    .signature-form-row {
        display: flex;
        align-items: flex-start;
        margin-bottom: 20px;
    }

    .signature-label {
        width: 112px;
        flex-shrink: 0;
        font-size: 14px;
        font-weight: 600;
        color: #2F2F2F;
        padding-top: 2px;
    }

    .signature-box {
        width: 305px;
        height: 116px;
        flex-shrink: 0;
        border: 1px solid #E5E7EB;
        border-radius: 6px;
        position: relative;
        background: #FFFFFF;
        overflow: hidden;
        box-sizing: border-box;
    }

    .btn-clear-sig {
        position: absolute;
        bottom: 12px;
        right: 20px;
        background: transparent;
        border: none;
        color: #ADADAD;
        font-size: 13px;
        cursor: pointer;
        padding: 0;
        outline: none;
    }

    .btn-clear-sig:hover {
        color: #6B7280;
    }

    .modal-actions-row {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .btn-batal {
        background: transparent;
        border: none;
        color: #F36F21;
        font-size: 13px;
        font-weight: 500;
        padding: 0;
        margin-right: 36px;
        box-shadow: none;
        cursor: pointer;
    }

    .btn-batal:hover {
        color: #D95D16;
        background: transparent;
    }

    .btn-konfirmasi {
        background-color: #F36F21;
        border: 1px solid #F36F21;
        color: #FFFFFF;
        font-size: 13px;
        font-weight: 500;
        border-radius: 4px;
        padding: 0;
        width: 99px;
        height: 32px;
        box-shadow: none;
        cursor: pointer;
        transition: background-color 0.2s;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .btn-konfirmasi:hover {
        background-color: #D95D16;
        border-color: #D95D16;
        color: #FFFFFF;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
        padding: 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body {
        margin: 0
    }

    .modal-body .moduleLine {
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a {
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover {
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox {
        border: 1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color: black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i {
        font-size: 5vh;
    }

    h3.modalHeadline {
        margin: 0 0 20px 0;
        font-weight: bold;
        text-align: center;
    }

    /* MODAL ENDS */

    .modal-body {
        max-height: 80vh;
        overflow-y: auto;
        overflow-x: auto;
    }
</style>